import contentTypes from "./contentTypes";

const fileExtensions = {
	[contentTypes.WAV]: "wav",
	[contentTypes.MP3]: "mp3",
	[contentTypes.JPEG]: "jpeg",
	[contentTypes.XML]: "xml",
	[contentTypes.JSON]: "json",
	[contentTypes.EXCEL]: "xlsx",
	[contentTypes.EPUB]: "epub",
	[contentTypes.PDF]: "pdf",
	[contentTypes.ZIP]: "zip",
	[contentTypes.TXT]: "txt",
};

export default fileExtensions;
